<template>
    <v-navigation-drawer
      v-model="toggle"
      fixed app
      dark
      >
      <v-list>
        <div style="padding:0px 0px 5px 20px">
          <img src="/static/img/bp_logo.png" alt="" width="165" height="82">
        </div>
        <v-divider></v-divider>
   
      </v-list>
       <v-list>
            <template v-if="loader_menu">
                 <loader-menu class="ml-3"></loader-menu>
            </template>
            <template v-else>
                  <v-list-tile @click="changeRoute('Dashboard')">
                    <v-list-tile-action>
                      <v-icon>dashboard</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-title :class="[{'active': isActive('Dashboard')}, 'item-title' ]">{{ ('Dashboard') }}</v-list-tile-title>
                  </v-list-tile>
                   <!--<v-list-tile @click="changeRoute('CompanyChart', 56)">
                    <v-list-tile-action>
                        <i class="fa fa-users font-icon"></i>
                     </v-list-tile-action>
                    <v-list-tile-title :class="[{'active': isActive('member-evaluation-list')}, 'item-title' ]">{{ ('Organization Chart') }}</v-list-tile-title>
                  </v-list-tile> -->
                <!-- CEO MENU -->
                 <template v-if="$store.state.USER_AUTH.user.role_id === 6 ">
                    <v-list-tile @click="changeRoute('ceoEmployeeList')">
                      <v-list-tile-action>
                        <i class="fa fa-users font-icon"></i>
                      </v-list-tile-action>
                      <v-list-tile-title :class="[{'active': isActive('ceoEmployeeList')}, 'item-title' ]">{{ ('Employee List') }}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="changeRoute('ceoleaverequest')">
                      <v-list-tile-action>
                        <i class="fa fa-plane font-icon"></i>
                      </v-list-tile-action>
                      <v-list-tile-title :class="[{'active': isActive('ceoleaverequest')}, 'item-title' ]">{{ ('Leave Request') }}
                        <span v-if="post_request.data != ''" class="badge badge-danger">{{post_request.data }}</span>
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="changeRoute('ceoNteRequest')">
                      <v-list-tile-action>
                        <i class="fa fa-balance-scale font-icon"></i>
                      </v-list-tile-action>
                      <v-list-tile-title :class="[{'active': isActive('ceoNteRequest')}, 'item-title' ]">{{ ('NTE Tracker') }}
                        <span v-if="asm_nte_item.data != ''" class="badge badge-danger">{{asm_nte_item.data}}</span>
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="changeRoute('ceo-evaluation-list')">
                      <v-list-tile-action>
                        <i class="fa fa-user-circle font-icon"></i>
                      </v-list-tile-action>
                      <v-list-tile-title :class="[{'active': isActive('ceo-evaluation-list')}, 'item-title' ]">{{ ('Evaluation List') }}
                        <span v-if="evaluation_item_asm > 0" class="badge badge-danger">{{evaluation_item_asm}}</span> 
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="changeRoute('ceoCoachingRecord')">
                      <v-list-tile-action>
                        <i class="fa fa-handshake-o font-icon"></i>
                      </v-list-tile-action>
                      <v-list-tile-title :class="[{'active': isActive('ceoCoachingRecord')}, 'item-title' ]">{{ ('Employee Coaching') }}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="changeRoute('ceo-calendar')">
                      <v-list-tile-action>
                        <i class="fa fa-calendar-o font-icon"></i>
                      </v-list-tile-action>
                      <v-list-tile-title :class="[{'active':isActive('ceo-calendar')}, 'item-title' ]">{{ ('Calendar') }}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="changeRoute('ceo-time-attendance')">
                      <v-list-tile-action>
                        <i class="fa fa-clock-o font-icon"></i>
                      </v-list-tile-action>
                      <v-list-tile-title :class="[{'active': isActive('ceo-time-attendance')}, 'item-title' ]">{{ ('Time & Attendance') }}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="changeRoute('settings')">
                      <v-list-tile-action>
                        <i class="fa fa-cogs font-icon"></i>
                      </v-list-tile-action>
                      <v-list-tile-title :class="[{'active': isActive('settings')}, 'item-title' ]">{{ ('Settings') }}</v-list-tile-title>
                    </v-list-tile>
                 </template>  
                <!-- SUPERVISOR MENU -->
                <div v-if="$store.state.USER_AUTH.user.role_id === 2">
                  <v-list-group prepend-icon="supervisor_account">
                    <v-list-tile slot="activator">
                      <v-list-tile-title class="item-title">{{ ('Members') }}
                        <span v-if="post_request.data != ''" class="badge badge-danger">{{post_request.data}}</span>
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="changeRoute('members-list')">
                      <v-list-tile-action>
                        <i class="fa fa-circle-o group-list-icon"></i>
                      </v-list-tile-action>
                      <v-list-tile-title :class="[{'active': isActive('member-list')}, 'item-title' ]">{{ ('List') }}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="changeRoute('memberleaverequest')">
                      <v-list-tile-action>
                        <i class="fa fa-circle-o group-list-icon"></i>
                      </v-list-tile-action>
                      <v-list-tile-title :class="[{'active': isActive('memberleaverequest')}, 'item-title' ]">{{ ('Requests') }}
                        <span v-if="post_request.data != ''" class="badge badge-danger">{{post_request.data}}</span>
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="changeRoute('nte-request')">
                      <v-list-tile-action>
                        <i class="fa fa-circle-o group-list-icon"></i>
                      </v-list-tile-action>
                      <v-list-tile-title :class="[{'active': isActive('nte-request')}, 'item-title' ]">{{ ('NTE Records') }}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="changeRoute('member-coaching-records')">
                      <v-list-tile-action>
                        <i class="fa fa-circle-o group-list-icon"></i>
                      </v-list-tile-action>
                      <v-list-tile-title :class="[{'active': isActive('member-coaching-records')}, 'item-title' ]">{{ ('Coaching Records') }}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="changeRoute('member-evaluation-list')">
                      <v-list-tile-action>
                        <i class="fa fa-circle-o group-list-icon"></i>
                      </v-list-tile-action>
                      <v-list-tile-title :class="[{'active': isActive('member-evaluation-list')}, 'item-title' ]">{{ ('Evaluation Records') }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list-group>
                </div>
                <!-- END SUPERVISOR MENU -->

                <!-- DEPARTAMENTAL MENU -->
                 <template v-if="$store.state.USER_AUTH.user.role_id === 3 ">
                    <v-list-group prepend-icon="supervisor_account">
                      <v-list-tile slot="activator">
                        <v-list-tile-title class="item-title">{{ ('Employee') }}
                           <span v-if="post_request.data != '' || evaluation_item_asm > 0" class="badge badge-danger">{{post_request.data + evaluation_item_asm + asm_nte_item.data}}</span>
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="changeRoute('employee-list')">
                        <v-list-tile-action>
                          <i class="fa fa-circle-o group-list-icon"></i>
                        </v-list-tile-action>
                        <v-list-tile-title :class="[{'active': isActive('employee-list')}, 'item-title' ]">{{ ('List') }}</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="changeRoute('employeerequest')">
                        <v-list-tile-action>
                          <i class="fa fa-circle-o group-list-icon"></i>
                        </v-list-tile-action>
                        <v-list-tile-title :class="[{'active': isActive('employeerequest')}, 'item-title' ]">{{ ('Requests') }}
                          <span v-if="post_request.data != ''" class="badge badge-danger">{{post_request.data}}</span>
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="changeRoute('employee-nte-request')">
                        <v-list-tile-action>
                          <i class="fa fa-circle-o group-list-icon"></i>
                        </v-list-tile-action>
                        <v-list-tile-title :class="[{'active': isActive('employee-nte-request')}, 'item-title' ]">{{ ('NTE Records') }}
                          <span v-if="asm_nte_item.data != ''" class="badge badge-danger">{{asm_nte_item.data}}</span>
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="changeRoute('employee-coaching-records')">
                        <v-list-tile-action>
                          <i class="fa fa-circle-o group-list-icon"></i>
                        </v-list-tile-action>
                        <v-list-tile-title :class="[{'active': isActive('employee-coaching-records')}, 'item-title' ]">{{ ('Coaching Records') }}</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="changeRoute('employee-evaluation-list')">
                        <v-list-tile-action>
                          <i class="fa fa-circle-o group-list-icon"></i>
                        </v-list-tile-action>
                        <v-list-tile-title :class="[{'active': isActive('employee-evaluation-list')}, 'item-title' ]">{{ ('Evaluation Records') }}
                          <span v-if="evaluation_item_asm > 0" class="badge badge-danger">{{evaluation_item_asm}}</span>
                        </v-list-tile-title>
                      </v-list-tile>
                    </v-list-group>
                 </template>

                
                  <!-- SUPERVISOR AND DEPARTAMENTAL MENU-->
                  <template v-if="($store.state.USER_AUTH.user.role_id === 3) || ($store.state.USER_AUTH.user.role_id === 2) ">
                      <v-list-group prepend-icon="perm_identity">
                        <v-list-tile slot="activator">
                          <v-list-tile-title class="item-title">{{ ('Personal') }}
                            <span v-if="coaching_item.data != '' || 
                                  my_nte_item.data != '' || 
                                  evaluation_item > 0 ||
                                  payslip_item > 0
                                  "
                                  class="badge badge-danger">
                                  {{coaching_item.data + my_nte_item.data + evaluation_item + payslip_item}}
                            </span>
                          </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="changeRoute('Profile')">
                          <v-list-tile-action>
                            <i class="fa fa-circle-o group-list-icon"></i>
                          </v-list-tile-action>
                          <v-list-tile-title :class="[{'active': isActive('Profile')}, 'item-title' ]">{{ ('My Profile') }}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="changeRoute('my-coaching-records')">
                          <v-list-tile-action>
                            <i class="fa fa-circle-o group-list-icon"></i>
                          </v-list-tile-action>
                          <v-list-tile-title :class="[{'active': isActive('my-coaching-records')}, 'item-title' ]">{{ ('Coaching Records') }}
                            <span v-if="coaching_item.data != ''" class="badge badge-danger">{{coaching_item.data}}</span>
                          </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="changeRoute('reports')">
                          <v-list-tile-action>
                            <i class="fa fa-circle-o group-list-icon"></i>
                          </v-list-tile-action>
                          <v-list-tile-title :class="[{'active': isActive('reports')}, 'item-title' ]">{{ ('NTE Records') }}
                            <span v-if="my_nte_item.data != ''" class="badge badge-danger">{{my_nte_item.data}}</span>
                          </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="changeRoute('my-evaluation-list')">
                          <v-list-tile-action>
                            <i class="fa fa-circle-o group-list-icon"></i>
                          </v-list-tile-action>
                          <v-list-tile-title :class="[{'active': isActive('my-evaluation-list')}, 'item-title' ]">{{ ('Evaluation Records') }}
                            <span v-if="evaluation_item > 0" class="badge badge-danger">{{evaluation_item}}</span>
                          </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="changeRoute('payslip')">
                          <v-list-tile-action>
                            <i class="fa fa-circle-o group-list-icon"></i>
                          </v-list-tile-action>
                          <v-list-tile-title :class="[{'active': isActive('payslip')}, 'item-title' ]">{{ ('Payslip') }}
                            <span v-if="payslip_item > 0" class="badge badge-danger">{{payslip_item}}</span>
                          </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="changeRoute('my-calendar')">
                          <v-list-tile-action>
                            <i class="fa fa-circle-o group-list-icon"></i>
                          </v-list-tile-action>
                          <v-list-tile-title :class="[{'active': isActive('my-calendar')}, 'item-title' ]">{{ ('Calendar') }}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="changeRoute('leaverequest')">
                          <v-list-tile-action>
                            <i class="fa fa-circle-o group-list-icon"></i>
                          </v-list-tile-action>
                          <v-list-tile-title :class="[{'active': isActive('leaverequest')}, 'item-title' ]">{{ ('Leave') }}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="changeRoute('undertimerequest')">
                          <v-list-tile-action>
                            <i class="fa fa-circle-o group-list-icon"></i>
                          </v-list-tile-action>
                          <v-list-tile-title :class="[{'active': isActive('undertimerequest')}, 'item-title' ]">{{ ('Undertime') }}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="changeRoute('adjustschedule')">
                          <v-list-tile-action>
                            <i class="fa fa-circle-o group-list-icon"></i>
                          </v-list-tile-action>
                          <v-list-tile-title :class="[{'active': isActive('adjustschedule')}, 'item-title' ]">{{ ('Adjustment') }}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="changeRoute('responsibility-form')">
                          <v-list-tile-action>
                            <i class="fa fa-circle-o group-list-icon"></i>
                          </v-list-tile-action>
                          <v-list-tile-title :class="[{'active': isActive('responsibility-form')}, 'item-title' ]">{{ ('Responsibility Form') }}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="changeRoute('documents')">
                          <v-list-tile-action>
                            <i class="fa fa-circle-o group-list-icon"></i>
                          </v-list-tile-action>
                          <v-list-tile-title :class="[{'active': isActive('documents')}, 'item-title' ]">{{ ('Requirements Tracker') }}</v-list-tile-title>
                        </v-list-tile>
                      </v-list-group>
                  </template>
                  <!-- END SUPEVISOR AND DEPARTAMENTAL MENU-->
                  
                  <!-- AGENT MENU -->
                  <template v-if="$store.state.USER_AUTH.user.role_id === 1 ">
                     <v-list-tile @click="changeRoute('Profile')">
                      <v-list-tile-action>
                        <i class="fa fa-user-o font-icon"></i>
                      </v-list-tile-action>
                      <v-list-tile-title :class="[{'active': isActive('Profile')}, 'item-title' ]">{{ ('My Profile') }}</v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="changeRoute('my-coaching-records')">
                      <v-list-tile-action>
                        <i class="fa fa-handshake-o font-icon"></i>
                      </v-list-tile-action>
                      <v-list-tile-title :class="[{'active': isActive('my-coaching-records')}, 'item-title' ]">{{ ('Coaching Records') }}
                        <span v-if="coaching_item.data != ''" class="badge badge-danger">{{coaching_item.data}}</span>
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="changeRoute('reports')">
                      <v-list-tile-action>
                        <i class="fa fa-clipboard font-icon"></i>
                      </v-list-tile-action>
                      <v-list-tile-title :class="[{'active': isActive('reports')}, 'item-title' ]">{{ ('NTE Records') }}
                        <span v-if="my_nte_item.data != ''" class="badge badge-danger">{{my_nte_item.data}}</span>
                      </v-list-tile-title>
                    </v-list-tile>
                    <v-list-tile @click="changeRoute('my-evaluation-list')">
                        <v-list-tile-action>
                          <i class="fa fa-gavel font-icon"></i>
                        </v-list-tile-action>
                        <v-list-tile-title :class="[{'active': isActive('my-evaluation-list')}, 'item-title' ]">{{ ('Evaluation') }}
                          <span v-if="evaluation_item > 0" class="badge badge-danger">{{evaluation_item}}</span>
                        </v-list-tile-title>
                    </v-list-tile>
                      <v-list-tile @click="changeRoute('payslip')">
                        <v-list-tile-action>
                          <i class="fa fa-money font-icon"></i>
                        </v-list-tile-action>
                        <v-list-tile-title :class="[{'active': isActive('payslip')}, 'item-title' ]">{{ ('Payslip') }}
                          <span v-if="payslip_item > 0" class="badge badge-danger">{{payslip_item}}</span>
                        </v-list-tile-title>
                      </v-list-tile>
                     <v-list-tile @click="changeRoute('my-calendar')">
                      <v-list-tile-action>
                       <i class="fa fa-calendar font-icon"></i>
                      </v-list-tile-action>
                      <v-list-tile-title :class="[{'active': isActive('my-calendar')}, 'item-title' ]">{{ ('Calendar') }}</v-list-tile-title>
                    </v-list-tile>
                      <v-list-group>
                        <v-list-tile slot="activator">
                            <i class="fa fa-paper-plane-o font-icon-group"></i>
                          <v-list-tile-title class="item-title">{{ ('Requests') }}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="changeRoute('leaverequest')">
                          <v-list-tile-action>
                            <i class="fa fa-circle-o group-list-icon"></i>
                          </v-list-tile-action>
                          <v-list-tile-title :class="[{'active': isActive('leaverequest')}, 'item-title' ]">{{ ('Leave') }}</v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click="changeRoute('undertimerequest')">
                            <v-list-tile-action>
                              <i class="fa fa-circle-o group-list-icon"></i>
                            </v-list-tile-action>
                            <v-list-tile-title :class="[{'active': isActive('undertimerequest')}, 'item-title' ]">{{ ('Undertime') }}</v-list-tile-title>
                         </v-list-tile>
                        <v-list-tile @click="changeRoute('adjustschedule')">
                          <v-list-tile-action>
                            <i class="fa fa-circle-o group-list-icon"></i>
                          </v-list-tile-action>
                          <v-list-tile-title :class="[{'active': isActive('adjustschedule')}, 'item-title' ]">{{ ('Adjustment') }}</v-list-tile-title>
                        </v-list-tile>
                      </v-list-group>
                      <v-list-tile @click="changeRoute('responsibility-form')">
                        <v-list-tile-action>
                          <i class="fa fa-edit font-icon"></i>
                        </v-list-tile-action>
                        <v-list-tile-title :class="[{'active': isActive('responsibility-form')}, 'item-title' ]">{{ ('Responsibility Form') }}</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="changeRoute('documents')">
                        <v-list-tile-action>
                        <i class="fa fa-folder-open-o font-icon"></i>
                        </v-list-tile-action>
                        <v-list-tile-title :class="[{'active': isActive('documents')}, 'item-title' ]">{{ ('Requirements Tracker') }}</v-list-tile-title>
                      </v-list-tile>
                  </template>
                  <!-- END AGENT MENU -->

                  <!-- GENERAL MENU EXCEPT COO -->
                  <template v-if="($store.state.USER_AUTH.user.role_id === 1) || ($store.state.USER_AUTH.user.role_id === 3) || ($store.state.USER_AUTH.user.role_id === 2)">
                      <v-list-tile @click="changeRoute('time-attendance')">
                        <v-list-tile-action>
                          <i class="fa fa-clock-o font-icon"></i>
                        </v-list-tile-action>
                        <v-list-tile-title :class="[{'active': isActive('time-attendance')}, 'item-title' ]">{{ ('Time & Attendance') }}</v-list-tile-title>
                      </v-list-tile>
                      <template v-if="$store.state.USER_AUTH.user.role_id === 3 || $store.state.USER_AUTH.user.role_id === 2">
                          <v-list-tile @click="changeRoute('holidays')">
                            <v-list-tile-action>
                              <i class="fa fa-calendar-check-o font-icon"></i>
                            </v-list-tile-action>
                            <v-list-tile-title :class="[{'active': isActive('holidays')}, 'item-title' ]">{{ ('Holidays') }}</v-list-tile-title>
                          </v-list-tile>
                          <v-list-tile @click="changeRoute('workschedule')">
                            <v-list-tile-action>
                              <i class="fa fa-calendar-plus-o font-icon"></i>
                            </v-list-tile-action>
                            <v-list-tile-title :class="[{'active': isActive('workschedule')}, 'item-title' ]">{{ ('Work Schedule') }}</v-list-tile-title>
                          </v-list-tile>
                      </template>
                      <!-- <template v-if="($store.state.USER_AUTH.user.role_id === 2) && ($store.state.USER_AUTH.user.module_access === '1')">
                          <v-list-tile @click="changeRoute('workschedule', 40)">
                            <v-list-tile-action>
                              <i class="fa fa-calendar-plus-o font-icon"></i>
                            </v-list-tile-action>
                            <v-list-tile-title :class="[{'active': isActive('member-evaluation-list')}, 'item-title' ]">{{ ('Work Schedule') }}</v-list-tile-title>
                          </v-list-tile>
                      </template> -->
                      <v-list-tile @click="changeRoute('contracts-memo')">
                        <v-list-tile-action>
                          <i class="fa fa-newspaper-o font-icon"></i>
                        </v-list-tile-action>
                        <v-list-tile-title :class="[{'active': isActive('contracts-memo')}, 'item-title' ]">{{ ('Contracts & Memos') }}
                          <span v-if="my_contract_memo_item.data != ''" class="badge badge-danger">{{my_contract_memo_item.data}}</span>
                        </v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="changeRoute('settings')">
                        <v-list-tile-action>
                          <i class="fa fa-cogs font-icon"></i>
                        </v-list-tile-action>
                        <v-list-tile-title :class="[{'active': isActive('settings')}, 'item-title' ]">{{ ('Settings') }}</v-list-tile-title>
                      </v-list-tile>
                      <v-list-tile @click="logoutAction">
                        <v-list-tile-action>
                          <i class="fa fa-sign-out font-icon"></i>
                        </v-list-tile-action>
                        <v-list-tile-title class="item-title">
                          {{('Logout') }}
                        </v-list-tile-title>
                      </v-list-tile>
                  </template>
                  <!-- END GENERAL END GENERAL MENU EXCEPT OM -->
          </template><!-- END V-ELSE-->
       </v-list>
    </v-navigation-drawer>
  </template>
  
  <script>
  /* eslint-disable */
  import { mapState } from 'vuex'
  export default {
    props: {
      toggle: {
          type: Boolean,
          required: false,
          default: false
      }
    },
  
    data() {
      return {
         loader_menu: true
      }
    },

     created() {
        //  this.supervisor_side()
        this.$store.dispatch('USER_AUTH/GET_USER')
        this.$store.dispatch('NOTIFICATION/NTE_NOTIFY_ME')
        this.$store.dispatch('NOTIFICATION/NTE_NOTIFY_ASM')
        this.$store.dispatch('NOTIFICATION/COACHING_COUNTER')
        this.$store.dispatch('NOTIFICATION/LOAD_REQUEST')
        this.$store.dispatch('NOTIFICATION/LOAD_PAYSLIP')
        this.$store.dispatch('NOTIFICATION/LOAD_EVALUATION')
        this.$store.dispatch('NOTIFICATION/LOAD_EVALUATION_ASM')
        this.$store.dispatch('NOTIFICATION/CONTRACT_MEMO_NOTIFY_ME')
        this.getCurrentUser()
      },

    methods: {

      logoutAction(){
         let token = localStorage.getItem("token")
          axios.post('api/logout', { token: this.token })
          .then(resp => {
            if(resp.status == 200){
                 this.$store.commit('USER_AUTH/LOGOUT_USER')
                 localStorage.removeItem('token')
                 localStorage.removeItem('emp_id')
                 localStorage.removeItem('role_id')
                 setTimeout(
                    this.$router.push({ name: 'Login-Layout' })
                 ,6000)
                 
            }
          })
      },

      getCurrentUser() {
        axios.get('api/userInfo')
          .then(response => {
            this.sub_department_id = response.data.sub_department_id;
            this.loader_menu = false
            console.log('response => ', response)
          })
          .catch(error => {
            console.log(error.response)
          });
      },

      isActive(routeName) {
         return this.$route.name === routeName;
       },

      changeRoute(routeName) {
        if (!routeName) return;
        return this.$router.push({ name: routeName });
      },
      
      logout_action() {
        axios.post('api/logout', {
          token: localStorage.getItem('token')
        })
          .then(resp => {
            localStorage.removeItem('token')
            localStorage.removeItem('emp_id')
            localStorage.removeItem('role_id')
            this.$store.commit('LOGOUT_USER', { module: 'USER_AUTH' })
            this.$router.push({ name: 'Login-Layout' })
          })
      }  
    },

    computed:{
      ...mapState('NOTIFICATION', [
            'payslip_item',
            'my_nte_item', 
            'asm_nte_item', 
            'coaching_item', 
            'post_request', 
            'evaluation_item', 
            'evaluation_item_asm', 
            'my_contract_memo_item'
          ]),
    }
  }
  </script>
  
  <style>
    .font-icon-group{
      font-size: 22px !important; 
      padding-right: 55px !important;
    }
   .font-icon{
      font-size: 22px !important; 
    }
    .toolbar {
      font-weight: bold;
      font-size: 18px;
    }
  
    .theme--dark.v-navigation-drawer {
      background: rgb(10,91,180);
      background: linear-gradient(27deg, rgba(10,91,180,1) 0%, rgba(60,90,209,1) 58%, rgba(13,80,153,1) 100%, rgba(16,27,179,1) 100%);  
    }
  
    .theme--dark.v-list {
       background:none;
       color: #fff;
       padding: 10px;
     }
  
    .toolbar .text {
      padding-left: 15px;
      color: white;
      text-decoration:none;
    }
  
    .item-title {
      font-size: 17px;
      font-weight: 500;
    }
    .item-sub-title {
      font-size: 15px;
      font-weight: 500;
    }
  
    .active {
      font-weight: bold;
      color:rgb(255, 254, 253);
    }

    .theme--dark.v-list .v-list__group--active:after, .theme--dark.v-list .v-list__group--active:before {
      background: hsla(0,0%,100%,.12);
     }
  
  .v-list__group__header .v-list__group__header--active{
    padding: 10px !important;
  }
    
    .group-list-icon{
      padding-left:22px;
      font-size: 12px;
      color:orange;
    }
  
  .custom-badge{
    margin-bottom: 20px !important;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/core/NavigationDrawer.vue